import { makeStyles } from '@/styles/theme/tss-react';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'Playlist',
})(({ spacing, breakpoints, brandColors, typography }, props) => ({
  playlistContainer: {
    width: '100%',
    justifyContent: 'center',
  },
  grid: {
    '& .swiper': {
      overflow: 'visible',
    },
  },
  videoContainer: {
    background: darkOrLightStyle(props)(
      brandColors.tintsNeutral20,
      brandColors.black
    ),
    borderRadius: typography.pxToRem(16),
    overflow: 'hidden',
    width: '100%',
    position: 'relative',
    paddingTop: '56.25%',

    '& iframe': {
      width: '100%',
      height: '100%',
    },
  },
  playerOverlay: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'rgba(0, 0, 0, 0.3)',
    top: 0,
    left: 0,
    cursor: 'pointer',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundColor: darkOrLightStyle(props)(
      brandColors.tintsNeutral20,
      brandColors.black
    ),

    '&:hover': {
      color: 'rgba(0, 0, 0, 0.6)',
    },
  },
  videoPlayer: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
  },
  eyebrowWrapper: {
    paddingTop: spacing(2),
    paddingBottom: spacing(-1),
  },
  navigationButtonDisabled: {
    opacity: 0.3,
  },
  swiperSlide: {
    width: 'fit-content !important',

    '&:not(:last-child)': {
      marginRight: spacing(2),
    },
  },
  navigation: {
    display: 'flex',
    justifyContent: 'center',
    gap: spacing(3),
    marginTop: spacing(2),
    cursor: 'pointer',
  },
  navigationHidden: {
    opacity: 0,
    height: 0,
  },
  navigationButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: typography.pxToRem(40),
    height: typography.pxToRem(40),
    borderRadius: typography.pxToRem(800),
    border: `${typography.pxToRem(1)} solid ${brandColors.primaryMain}`,
    color: darkOrLightStyle(props)(brandColors.white, brandColors.primaryMain),
    borderColor: darkOrLightStyle(props)(
      brandColors.white,
      brandColors.primaryMain
    ),

    [breakpoints.up('sm')]: {
      width: typography.pxToRem(60),
      height: typography.pxToRem(60),
    },
    '&:hover, &:focus': {
      backgroundColor: darkOrLightStyle(props)(
        brandColors.foregroundInverseSubtle,
        brandColors.interactiveHeroBlueSubtle
      ),
    },
  },
}));

export default useStyles;
